import React, { FC, useContext } from 'react';
import { AddToFoldersFetcher } from '../../../../folders/dropdown/AddToFoldersFetcher';
import { AddOneDecisionToFolderDropdown } from '../../../../folders/dropdown/AddOneDecisionToFolderDropdown';
import { FoldersDropdownContext } from '../../../../folders/dropdown/FoldersDropdownContext';

type Props = { docId: string };

export const SearchDecisionFoldersDropdown: FC<Props> = ({ docId }) => {
  const { showDropdown } = useContext(FoldersDropdownContext);
  if (!showDropdown) return null;
  return (
    <AddToFoldersFetcher docId={docId}>
      {({ isLoading }) => (
        <AddOneDecisionToFolderDropdown isLoading={isLoading} docId={docId} />
      )}
    </AddToFoldersFetcher>
  );
};
